import type { Instruction } from '@/features/instructions/types'
import { ArticleCover } from './ArticleCover'

interface Props {
  article: Instruction
  selected: boolean
  onSelect: (id: number) => void
}

/** Карточка статьи в выборе для блока — та же, что в разделе инструкций, без правки. */
export const ArticlePickTile = ({ article, selected, onSelect }: Props) => {
  return (
    <button
      type="button"
      onClick={() => onSelect(article.id)}
      aria-pressed={selected}
      className="relative aspect-[4/5] text-left transition-transform duration-300 hover:scale-[1.02] focus:outline-none"
    >
      <ArticleCover article={article} selected={selected} />
    </button>
  )
}
